import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { BookingFormData } from "../../state/BookingDiagnostics/FormData";

const updateFormData: Reducer<BookingFormData> = (state: BookingFormData = new BookingFormData(), action: Action<ActionType, BookingFormData>) => {
  switch (action.type) {
    case ActionType.BOOKING_DIAGNOSTICS_FORM_UPDATED:
      return { ...state, ...action.data };
    case ActionType.BOOKING_DIAGNOSTICS_FORM_IDENTITY_UPDATED:
      return { ...state, identity: action.data };
    case ActionType.BOOKING_DIAGNOSTICS_FORM_RESET:
      return new BookingFormData(action.data);
    default:
      return state;
  }
};

export default updateFormData;
